import React, { useState, useEffect } from 'react';
import { useGetUser, useSetUser } from '../../context/userContext';
import editUser from '../../api/editUser';

const BasicInformations = () => {
  const user = useGetUser();
  const setUser = useSetUser();
  const [edit, setEdit] = useState(false);
  const [userCopy, setUserCopy] = useState(user);

  useEffect(() => {
    setUserCopy(user);
  }, [user]);

  return (
    <div className="row mycard">
      <div className="col col-12 col-md-4 p-0">
        <div className="photo">
          <div className="image" style={{ backgroundImage: 'url(./images/no-photo.png)' }}></div>
          <div className="image-buttons">
            <button className="btn btn-secondary-outline p-1 w-100" onClick={() => alert('TODO: Implement file storage...')}>
              <i className="bi bi-pencil-fill"></i> Edit
            </button>
          </div>
        </div>
      </div>
      <div className="col col-12 col-md-8">
        {edit ? <EditInfo userCopy={userCopy} setUserCopy={setUserCopy} user={user} setUser={setUser} setEdit={setEdit} /> : <Info userCopy={userCopy} setEdit={setEdit} />}
      </div>
    </div>
  );
};

export default BasicInformations;

const Info = ({ userCopy, setEdit }) => {
  return (
    <div className="content">
      <div className="main">
        <h1 className="mb-0">{userCopy.username}</h1>

        <p className="lead">{userCopy.position}</p>
        <p>
          {!userCopy.city && !userCopy.country ? null : (
            <>
              <i className="bi bi-geo-alt-fill"></i> {userCopy.city ? userCopy.city + ',' : null} {userCopy.country ? userCopy.country : null}
            </>
          )}
        </p>
      </div>
      <div className="aside">
        <button className="btn btn-sm profile-btn" onClick={() => setEdit(true)}>
          <i className="bi bi-pencil-fill"></i> Edit
        </button>
      </div>
    </div>
  );
};

const EditInfo = ({ userCopy, setUserCopy, user, setUser, setEdit }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    editUser(userCopy, setUser);
    setEdit(false);
  };

  const handleCancel = () => {
    setUserCopy(user);
    setEdit(false);
  };

  return (
    <div className="content">
      <div className="main">
        <form className="row g-3" onSubmit={(e) => handleSubmit(e)}>
          <div className="col-12 col-md-12">
            <label htmlFor="inputName" className="form-label">
              Name
            </label>
            <input
              type="text"
              className="form-control"
              id="inputName"
              placeholder="Name"
              value={userCopy.username}
              onChange={(e) =>
                setUserCopy((prev) => {
                  return { ...prev, username: e.target.value };
                })
              }
            />
          </div>

          <div className="col-12">
            <label htmlFor="inputCurrentPosition" className="form-label">
              Current profession
            </label>
            <input
              type="text"
              className="form-control"
              id="inputCurrentPosition"
              placeholder="Current profession"
              value={userCopy.position}
              onChange={(e) =>
                setUserCopy((prev) => {
                  return { ...prev, position: e.target.value };
                })
              }
            />
          </div>

          <div className="col-12 col-md-6">
            <label htmlFor="inputCountry" className="form-label">
              Country
            </label>
            <select
              id="inputCountry"
              className="form-select"
              value={userCopy.country}
              onChange={(e) =>
                setUserCopy((prev) => {
                  return { ...prev, country: e.target.value };
                })
              }
            >
              <option value=""></option>
              <option value="Poland">Poland</option>
              <option value="Czech Republic">Czech Republic</option>
              <option value="Slovakia">Slovakia</option>
              <option value="Bulgaria">Bulgaria</option>
              <option value="Many others...">Many others...</option>
            </select>
          </div>

          <div className="col-12 col-md-6">
            <label htmlFor="inputCity" className="form-label">
              City
            </label>
            <input
              type="text"
              className="form-control"
              id="inputCity"
              placeholder="City"
              value={userCopy.city}
              onChange={(e) =>
                setUserCopy((prev) => {
                  return { ...prev, city: e.target.value };
                })
              }
            />
          </div>

          {/* <div className="col-12">
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="checkid" />
              <label className="form-check-label" htmlFor="checkid">
                Check me out
              </label>
            </div>
          </div> */}

          <div className="col-12 text-end">
            <button type="button" className="btn profile-btn inver mb-1" onClick={handleCancel}>
              Cancel
            </button>
            <button type="submit" className="btn profile-btn mb-1 ms-3">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
